<app-modal-container
  [bigSize]="false"
  [title]="'Add point of contact'"
  [titleDirection]="'start'"
  [spinnerProps]="spinnerProps"
  [buttons]="{}"
  [formGroup]="contactPersonForm">
  <div class="centered-column-container column-gap-1">
    <div class="centered-row-container row-gap-1 width-30">
      <app-input
        data-qa="kpi-contact-person-name"
        class="width-50pcnt"
        formControlName="name"
        [maxLength]="250"
        [title]="'Name'"
        [placeholder]="'Name'">
      </app-input>
      <ng-container>
        <app-input
          data-qa="kpi-contact-person-email"
          class="width-50pcnt"
          formControlName="email"
          [maxLength]="250"
          [additionalClass]="contactPersonForm.controls.email.invalid ? 'error' : ''"
          [title]="'Email'"
          [placeholder]="'Email'">
        </app-input>
      </ng-container>
    </div>
    <div class="space-between-horizontal-centered width-100pcnt">
      <app-button
        data-qa="kpi-contact-person-email-delete"
        [size]="'modal-container-button'"
        [type]="'light-red'"
        [iconName]="'delete.svg'"
        (buttonClick)="resetPerson()">
        Delete
      </app-button>
      <div class="centered-row-container row-gap-0p5">
        <app-button
          data-qa="kpi-contact-person-email-cancel"
          [size]="'modal-container-button'"
          [type]="'grey'"
          (buttonClick)="close(false)">
          Cancel
        </app-button>
        <app-button
          data-qa="kpi-contact-person-email-apply"
          [size]="'modal-container-button'"
          [type]="'accent'"
          [disabled]="contactPersonForm.controls.email.invalid"
          (buttonClick)="apply()">
          Apply
        </app-button>
      </div>
    </div>
  </div>
</app-modal-container>
